<template>
  <div>
    <div class="loading-state-container" v-if="isLoading">
      <div class="container">
        <PreloaderSection />
      </div>
    </div>
    <div v-if="!isLoading">
      <router-view
        v-if="!isError"
        :collectionData="collection"
        :isLoading="areItemsLoading"
        @onSortByChange="handleSort"
        @onSortOrderChange="handleSortOrder"
        :lastPage="collectionLastPage" />
      <ErrorMessageCollectionContainer
        v-if="isError"
        :error="loadCollectionState.error"
        :redirectLink="'/collections'" />
    </div>
  </div>
</template>

<script>

import _ from 'lodash';
import { mapGetters } from 'vuex';
import PreloaderSection from '@/components/PreloaderSection.vue';
import ErrorMessageCollectionContainer from './ErrorMessageCollectionContainer.vue';

export default {
  components: {
    PreloaderSection,
    ErrorMessageCollectionContainer,
  },
  data() {
    return {
      areItemsLoading: true,
      lastPage: null,
    };
  },
  created() {
    if (this.collectionId !== 'create') {
      const filter = null;
      this.load(filter, this.collectionId);
    }
  },
  watch: {
    filter() {
      this.loadItems(this.collectionId);
    },
  },
  computed: {
    ...mapGetters(['collection', 'collectionItems', 'loadCollectionState', 'isCollectionDynamic', 'collectionLastPage']),
    isLoading() {
      return this.loadCollectionState.isLoading;
    },
    isError() {
      return this.loadCollectionState.isError;
    },
    collectionType() {
      return this.$route.params;
    },
    collectionId() {
      return this.$route.params.collectionId;
    },
    filter() {
      return this.$route.query;
    },
  },
  methods: {
    handleSort(value) {
      if (value === 'createdAt') {
        const sortedCollectionItem = _.sortBy(this.collectionItems, (item) => {
          return _.get(item, 'video.updatedAt', null);
        });
        this.$store.dispatch('setCollectionItems', { payload: sortedCollectionItem });
      }
      // if (value === 'manual') {
      //   const filter = { limit: 'all' };
      //   this.loadItems(filter, this.collectionId);
      // } else {
      //   const filter = null;
      //   this.loadItems(filter, this.collectionId);
      // }
    },
    handleSortOrder(value) {
      this.$store.dispatch('setCollectionAttribute', { key: 'sortOrder', value });
      this.loadItems(this.collectionId);
    },
    async load(filter, collectionId) {
      this.$store.dispatch('loadCollectionById', collectionId)
        .then(() => {
          this.loadItems(collectionId);
        });
    },
    async loadItems(collectionId) {
      this.areItemsLoading = true;
      const params = { ...this.filter, collectionId };
      await this.$store.dispatch('setCollectionDynamicState', 'load');
      await this.$store.dispatch('loadCollectionItemsById', params);
      this.areItemsLoading = false;
    },
    getTagId(tag) {
      const tagIds = _.map(tag, (item) => { return item.id; });
      return tagIds.join();
    },
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/scss/variables.scss';

.loading-state-container {
  margin-top: $spacer * 6;
}
</style>
